module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tel"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('h5', [_vm._v("校园服务电话")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content_top"
  }, [_c('section', {
    staticClass: "left"
  }, [_c('p', [_vm._v("学校信访办：67843328")]), _vm._v(" "), _c('p', [_vm._v("校园110：67843110")]), _vm._v(" "), _c('p', [_vm._v("学生管理科：67842955")]), _vm._v(" "), _c('p', [_vm._v("心理咨询预约：67842501")]), _vm._v(" "), _c('p', [_vm._v("学生宿管中心：67842796")]), _vm._v(" "), _c('p', [_vm._v("学生资助中心：67842722")])]), _vm._v(" "), _c('section', {
    staticClass: "rigth"
  }, [_c('p', [_vm._v("研究生院：67842498")]), _vm._v(" "), _c('p', [_vm._v("团委（社团活动）：67841396")]), _vm._v(" "), _c('p', [_vm._v("教务处：67843341")]), _vm._v(" "), _c('p', [_vm._v("食堂服务：15927076739")]), _vm._v(" "), _c('p', [_vm._v("校园网服务：67843672")]), _vm._v(" "), _c('p', [_vm._v("教室网络设备服务：67843900")])])]), _vm._v(" "), _c('div', {
    staticClass: "content_bottom"
  }, [_c('section', {
    staticClass: "left"
  }, [_c('p', [_vm._v("水电中心电话：67842055")]), _vm._v(" "), _c('p', [_vm._v("校园卡服务：67842559、67841627、87058095（北区）")]), _vm._v(" "), _c('p', [_vm._v("校医院急诊：15802793857")]), _vm._v(" "), _c('p', [_vm._v("毕业生就业：67842082")]), _vm._v(" "), _c('p', [_vm._v("毕业生档案：67841629")]), _vm._v(" "), _c('p', [_vm._v("毕业生党组织关系咨询：67844311")]), _vm._v(" "), _c('p', [_vm._v("学校法律援助中心：67843217")]), _vm._v(" "), _c('p', [_vm._v("物业服务：87383036（东区）、87572081（西区及当代）")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e33815ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tel.vue
// module id = 573
// module chunks = 0